export enum StatusType {
  Info = 'info',
  Success = 'success',
  Error = 'error',
  LightBlue = 'light-blue',
  Branded = 'branded',
  None = 'none',
}
